export const isRequired = fieldName => `${fieldName} is required`

export const isEmail = fieldName => 'Please enter a valid email address'

export const isLimitedLength = fieldName => `${fieldName} is too long`

export const isLimitedInteger = fieldName => `${fieldName} value is too big`

export const isAlphanumeric = fieldName => 'Please use Latin alphabet and numbers only'

export const isNumeric = fieldName => 'Please use numbers only'

export const isPhoneNumber = fieldName => 'Please use valid phone number'

export const onlyLatinSymbols = fieldName => `${fieldName} should not contain non-latin symbols`

export const isUsername = fieldName => 'Please use only latin symbols, numbers or a hyphen symbol ( - )'

export const maxLength = length => (fieldName) => `${fieldName} can't be longer than ${length} characters`

export const minLength = length => (fieldName) => `${fieldName} can't be shorter than ${length} characters`

export const min = length => (fieldName) => `${fieldName} can't be less than ${length}`

export const max = length => (fieldName) => `${fieldName} can't be more than ${length}`

export const validateCompetitors = fieldName => 'Please note that advertising other marketplaces is not allowed on your product information'

export const minArrLength = length => (fieldName) => `At least ${length} ${fieldName} are required`

export const maxArrLength = length => (fieldName) => `There can't be more than ${length} ${fieldName}`

export const decimalPrice = fieldName => `${fieldName} can't have more than two decimal values`

export const notLowerThan50Percent = fieldName => 'Price offers should not be below the minimum of 50% of the original price'

export const noEmoji = fieldName => 'Emojis are not allowed'
